export const s3Credentials = {
  bucketName: "dev-fidweb",
  dirName: "idea-erp",
  region: "eu-central-1",
  accessKeyId: "AKIA5L7PZ7W5LIVFASGG",
  secretAccessKey: "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",
};
